<div class="day-grid">
  @for (row of rows; track $index) {
    @for (day of row; track day) {
      <button class="day-cell" type="button" [class.selected]="isSelected(day)" [attr.aria-pressed]="isSelected(day)" [attr.data-day]="day" [disabled]="$disabled()" (click)="onToggle(day)">{{ day }}</button>
    }
  }

  @for (day of tail; track day) {
    <button class="day-cell" type="button" [class.selected]="isSelected(day)" [attr.aria-pressed]="isSelected(day)" [attr.data-day]="day" [disabled]="$disabled()" (click)="onToggle(day)">{{ day }}</button>
  }

  <button class="day-cell day-cell-last" type="button" [class.selected]="isSelected(lastDay)" [attr.aria-pressed]="isSelected(lastDay)" [attr.data-day]="lastDay" [disabled]="$disabled()" (click)="onToggle(lastDay)">Last day</button>
  <span class="day-cell-spacer"></span>
</div>

@if ($showFootnote()) {
  <p class="day-grid-footnote">Months without this day use the last day instead</p>
}
